import AcMovementDetailsDetailsTab from './details/details';

export default {
  Details: AcMovementDetailsDetailsTab,
};
